import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { IOfferData, OfferTypesEnum } from './pricing-data.data';
import { ActionsEnum, FetchOffer, SetOffer } from './pricing-data.actions';

// feature name
export const FEATURE_NAME = 'pricing-data';

// state interface
export interface IState {
  offers: IOfferData;
}

// initial state
export const initialState: IState = {
  offers: {},
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.FETCH_OFFER]: function (
      state: IState,
      { payload }: FetchOffer
    ): IState {
      const { offerType } = payload;

      return {
        ...state,
        offers: {
          ...state.offers,
          [offerType]: null,
        },
      };
    },
    [ActionsEnum.SET_OFFER]: function (
      state: IState,
      { payload }: SetOffer
    ): IState {
      const { offerType, offer } = payload;

      return {
        ...state,
        offers: {
          ...state.offers,
          [offerType]: offer,
        },
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getOfferByType = (offerType: OfferTypesEnum) =>
  createSelector(selectFeature, (state: IState): any => {
    return state.offers[offerType];
  });
